export const messages = {
  collections: {
    id: 'admin/promotions.form.buy-and-win.trigger.collections',
  },
  skus: {
    id: 'admin/promotions.form.buy-and-win.trigger.skus',
  },
}
